<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row">
            <div class="col-sm-6">
                <div class="title-wrapper">
                    <h1 class="title-default">Perfis</h1>
                    <p class="welcome-message">Gerenciamento de Perfis</p>
                </div>
            </div>
            <div class="col-sm-6">
                <a type="button" mat-flat-button class="btn-primary btn-add-right"
                    routerLink="/configuracoes/perfil/cadastrar">
                    <mat-icon>add</mat-icon>
                    Novo Perfil
                </a>
            </div>
        </div>
        <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Buscar</mat-label>
                        <input matInput formControlName="pesquisa" type="text">
                        <button mat-icon-button matSuffix type="button" (click)="clickPesquisar()"
                            aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(this._listaPerfilResponse && this._listaPerfilResponse.listaPerfil.length > 0){
        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="idPerfil">
                <th mat-header-cell *matHeaderCellDef> # </th>
                <td mat-cell *matCellDef="let element"> {{element.perfil.idPerfil}} </td>
            </ng-container>

            <ng-container matColumnDef="nomePerfil">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome perfil </th>
                <td mat-cell *matCellDef="let element"> {{element.perfil.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef> Descrição </th>
                <td mat-cell *matCellDef="let element"> {{element.perfil.descricao}} </td>
            </ng-container>

            <ng-container matColumnDef="restricoes">
                <th mat-header-cell *matHeaderCellDef> Restrições </th>
                <td mat-cell *matCellDef="let element">
                    @if (element.possuiRestricaoIp) {
                        <span class="material-symbols-outlined" matTooltip="Restrição de IP" style="font-size: 18px; vertical-align: middle; margin-right: 4px;">location_off</span>
                    }
                    @if (element.possuiRestricaoHorario) {
                        <span class="material-symbols-outlined" matTooltip="Restrição de horário" style="font-size: 18px; vertical-align: middle;">schedule</span>
                    }
                    @if (!element.possuiRestricaoIp && !element.possuiRestricaoHorario) {
                        <span>-</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/perfil/cadastrar', {idPerfil: element.perfil.idPerfil}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="abrirModalExcluir(element.perfil.idPerfil, element.perfil.nome)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of _dataSource.data; track item.perfil.idPerfil) {
            <div class="card-mobile mb-3">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <span class="text-bold">{{item.perfil.nome}}</span>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/perfil/cadastrar', {idPerfil: item.perfil.idPerfil}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="abrirModalExcluir(item.perfil.idPerfil, item.perfil.nome)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    @if (item.perfil.descricao) {
                    <p class="mb-1"><strong>Descrição:</strong> {{item.perfil.descricao}}</p>
                    }
                    <p class="mb-1 d-flex align-items-center gap-1"><strong>Restrições:</strong>
                        @if (item.possuiRestricaoIp) {
                        <span class="material-symbols-outlined" matTooltip="Restrição de IP"
                            style="font-size: 18px; vertical-align: middle;">location_off</span>
                        }
                        @if (item.possuiRestricaoHorario) {
                        <span class="material-symbols-outlined" matTooltip="Restrição de horário"
                            style="font-size: 18px; vertical-align: middle;">schedule</span>
                        }
                        @if (!item.possuiRestricaoIp && !item.possuiRestricaoHorario) {
                        <span>-</span>
                        }
                    </p>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center ver-mais-pesquisa">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                Ver mais
                }
            </button>
        </div>
        }@else if(_isLoading === true){
        <app-loading-box-default-list></app-loading-box-default-list>
        }
        @else if(this._listaPerfilResponse?.listaPerfil?.length === 0){
        <app-empty-list [title]="'Não foi encontrado nenhum perfil com o filtro informado'"></app-empty-list>
        }
    </div>
</div>
